import { Home, Compass, ImageIcon, Play, UserCircle, Hexagon, Heart, HelpCircle, BookOpen, FastForward } from "lucide-react";
import type { ElementType } from "react";

export interface NavItem {
  href: string;
  label: string;
  icon: ElementType;
}

export const navItems: NavItem[] = [
  { href: "/", label: "Home", icon: Home },
  { href: "/explore", label: "Explore", icon: Compass },
  { href: "/academy", label: "Academy", icon: BookOpen },
  { href: "/assets", label: "Assets", icon: ImageIcon },
];

export const creationNavItems: NavItem[] = [
  { href: "/create-character", label: "Create Character", icon: UserCircle },
  { href: "/animate-character", label: "Animate Character", icon: Play },
  { href: "/extend-video", label: "Extend Video", icon: FastForward },
];

export const utilityNavItems: NavItem[] = [
  { href: "/billing", label: "Gizmos", icon: Hexagon },
  { href: "/affiliates", label: "Affiliate", icon: Heart },
  { href: "/support", label: "Support", icon: HelpCircle },
];
